import { getConfig } from '../config'
import { getLocaleLanguage, LanguageType } from '../utils/language'
import { captchaVerifyFailReport } from '../utils/report'

export const loadCaptchaScript = () => {
  const url = getConfig().captchaTencent.scriptURL
  if (!url) {
    console.error('[loadCaptchaScript] app config empty')
    return
  }
  const script = document.createElement('script')
  script.setAttribute('src', url)
  script.setAttribute('src', url)
  script.defer = true
  document.body.insertBefore(script, document.body.children[0])
}

const checkCaptchaCallback = (res, callback, errorCallback, retryCount = 0, email = '') => {
  const canRetry = retryCount < 3
  if (canRetry && res.errorCode) {
    console.log('check captcha failed', res)
    // 防水墙（安平验证码） 走的另一套逻辑
    // https://iwiki.woa.com/p/1794654729#31-%E5%89%8D%E7%AB%AF%E9%94%99%E8%AF%AF%E7%A0%81
    if(res.errorCode === 1014 ) {
      captchaVerifyFailReport(email, `errMsg: ${res.errorMessage}`)
    }
    if (canRetry) {
      setTimeout(() => {
        showCaptchaWithRetry(callback, errorCallback, retryCount + 1, email)
      }, 100) // 重试
    }
    return
  }

  if (res.ret === 0 && res.ticket) {
    console.log('check captcha success', res)
    callback(res.ticket, res.randstr)
  } else {
    console.log('check captcha failed', res)
    errorCallback()
  }
}

// 验证码js加载错误处理
const loadCaptchaJsErrorCallback = (callback, errorCallback, retryCount = 0, email = '') => {
  const appID = getConfig().captchaTencent.appID
  // 生成票据或自行做其它处理
  const ticket = 'terror_1001_' + appID + Math.floor(new Date().getTime() / 1000)
  checkCaptchaCallback({
    ret: 0,
    randstr:
      '@' +
      Math.random()
        .toString(36)
        .substr(2),
    ticket,
    errorCode: 1001,
    errorMessage: 'jsload_error'
  }, callback, errorCallback, retryCount, email)
}

// 带重试功能的验证码显示函数
const showCaptchaWithRetry = (callback, errorCallback, retryCount = 0, email = '') => {
  try {
    const appID = getConfig().captchaTencent.appID
    if (!appID) {
      console.error('[showCaptcha] app config empty')
      return
    }
    const language = getLocaleLanguage() || LanguageType.en_US
    // 生成一个验证码对象
    // eslint-disable-next-line no-undef

    const captcha = new TencentCaptcha(
      appID, // 验证码appid
      res => checkCaptchaCallback(res, callback, errorCallback, retryCount, email), // 验证码回调函数
      {
        // 验证码options配置参数
        userLanguage: language, // 指定语言
        needFeedBack: false, // 不需要帮助按钮
        // 天御特有的，回调函数
        verifyFn: (callback) => {
          // console.log('verifyFn', callback)
          // 未通过天御验证码校验时上报
          if (!callback.pass) {
            captchaVerifyFailReport(email, `sid: ${callback.sid}`)
          }
        }
      }
    )
    // 显示验证码
    captcha.show()
  } catch (error) {
    console.log('show captcha error: ', error)
    if (retryCount < 3) {
      console.log(`JS加载错误，第${retryCount + 1}次重试...`)
      setTimeout(() => {
        showCaptchaWithRetry(callback, errorCallback, retryCount + 1, email)
      }, 500) // 重试
    } else {
      loadCaptchaJsErrorCallback(callback, errorCallback, retryCount, email)
    }
  }
}

export const showCaptcha = (callback, errorCallback, email = '') => {
  showCaptchaWithRetry(callback, errorCallback, 0, email)
}



// WEBPACK FOOTER //
// ./src/utils/captcha.js